module.exports = __webpack_public_path__ + "media/draw.ab41d09e.mp3";